import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import * as $ from 'jquery';
import {OlapService} from '../../service/olap-service.service'
import { Subscription } from 'rxjs/Subscription';
import { Router } from '@angular/router';
import { environment } from 'environments/environment';
import Cookies from 'js-cookie';
import { LoanService } from 'app/service/loan.service';

@Component({
  selector: 'app-header',
  templateUrl: './app-header.component.html',
  styles: [`
    .noselect {
      -webkit-touch-callout: none; /* iOS Safari */
        -webkit-user-select: none; /* Safari */
          -khtml-user-select: none; /* Konqueror HTML */
            -moz-user-select: none; /* Firefox */
            -ms-user-select: none; /* Internet Explorer/Edge */
                user-select: none; /* Non-prefixed version, currently
                                      supported by Chrome and Opera */
      outline: none;
    }
    .btn-circle.btn-xl {
      width: 70px;
      height: 70px;
      // padding: 10px 16px;
      border-radius: 35px;
      font-size: 24px;
      line-height: 1.33;
      color: yellow;
      font-family: sans-serif;
      font-size: 1em;
      font-weight: bold;
      margin-right: 10px !important;
      }

    .btn-circle {
        width: 30px;
        height: 30px;
        padding: 0px 0px;
        border-radius: 15px;
        text-align: center;
        font-size: 12px;
        line-height: 1.42857;
    }
  `]
})
export class AppHeaderComponent implements OnInit, OnDestroy { 
  private name:string = 'name';
  isLoggedIn:boolean = false;
  isStaff:boolean = false;
  isHr:boolean = false;
  isCreditGrp:boolean = false;
  private subscription: Subscription;

  constructor (private olapService: OlapService,
              private router: Router,
              private loanService: LoanService) {
    console.log('App header constructor')
    this.subscription = this.olapService.getHeaderState().subscribe(
      headerState => {
        console.log('headerState: ' + headerState)
        if (headerState) {
          this.setHeader();
        }
    });
    if (Cookies.get('csrftoken') != undefined) {
      this.isLoggedIn = true;
    }
    if (Cookies.get('isStaff') == 'true') {
      this.isStaff = true;
    }
    if (Cookies.get('OLAP_UserGroup') && Cookies.get('OLAP_UserGroup').includes('credit_group')) {
      this.isCreditGrp = true;
    }
    if (Cookies.get('OLAP_UserGroup') && Cookies.get('OLAP_UserGroup').includes('olap_hr_clients')) {
      this.isHr = true;
    }
  }
  
  ngOnInit() :void { }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  setHeader() {
    console.log('set header')
    $('.default-buttons').css('display', 'none');
    $('.login-menu').css('display', 'inherit');
    this.isLoggedIn = true;
    this.name = name;
  }

  gotoContactUs() {
    this.router.navigateByUrl('/pages/contactus');
  }

  gotoLogin() {
    this.router.navigateByUrl( '/pages/login' );
  }

  gotoApply(isLoggedIn, isStaff) {
      // START HERE - [Salary Loan] Duplicate Application Prevention
      if (isLoggedIn && !isStaff) {
          this.loanService.checkNotAllowedForNewLoan();
      } else {
          this.router.navigateByUrl('/olap_apply#new');
      }
      // END HERE - [Salary Loan] Duplicate Application Prevention
  }

  gotoLoansPage() {
    this.router.navigateByUrl( '/olap_loans' );
  }

  gotoPromosPage() {
    this.router.navigateByUrl( '/olap_promotions' );//'/olap_promos' );
  }

  logout() {
    let self = this
    var loginData = {
      method: 'logout'
    }
    $.ajax({
      url: environment.apiUrl + 'client/', 
      type: 'POST',
      data: JSON.stringify(loginData),
      contentType: 'application/json',
      success: function() {
        Cookies.remove('csrftoken')
        Cookies.remove('isStaff');
        Cookies.remove('OLAP_UserGroup');
        Cookies.remove('reviewId')
        document.cookie = "csrftoken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=" + environment.domain;
        self.router.navigateByUrl('/pages/login#logout')
      },
      error: function(request, status, error) {
        Cookies.remove('csrftoken')
        Cookies.remove('isStaff')
        Cookies.remove('OLAP_UserGroup')
        Cookies.remove('reviewId')
        document.cookie = "csrftoken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=" + environment.domain;
        self.router.navigateByUrl('/pages/login#logout')
      }
    });
  }
}


// WEBPACK FOOTER //
// /opt/tglfc/olap/salary_web/src/app/components/app-header/app-header.component.ts